<template>
    <div class="search-result"></div>
    <div class="top-section">
        <span class="text">{{ $trans('web_search.profile_placeholder.search_results') }}</span>
        <div class="buttons-container">
            <button class="btn add-to-board-btn" disabled>
                {{ $trans('web_search.profile_placeholder.save_all_candidates') }}
                <img src="/media/images/web_search/clipboard-plus.svg" alt="icon" class="icon" />
            </button>
        </div>
    </div>
    <div class="wrapper">
        <div v-for="n in cardsToShow" :key="'placeholder-' + n" class="profile-placeholder"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cardsToShow: 6,
        };
    },
    mounted() {
        this.updateCardsToShow();
        window.addEventListener("resize", this.updateCardsToShow);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.updateCardsToShow);
    },
    methods: {
        updateCardsToShow() {
            const width = window.innerWidth;
            if (width >= 2100) {
                this.cardsToShow = 12;
            } else if (width >= 1440) {
                this.cardsToShow = 6;
            } else if (width >= 1024) {
                this.cardsToShow = 6;
            } else {
                this.cardsToShow = 6;
            }
        }
    }
};
</script>

<style scoped>
.search-result {
    margin-top: 10px;
    font-size: 18px;
    color: #3C3C3C;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 10.8%;
    width: 79%;
    padding-bottom: 20px;
    border-bottom: 1px solid #343433;
    box-sizing: border-box;
}

.top-section {
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: flex-start;
    color: #000;
    width: 79%;
    left: 10px;
    margin-left: 11%;
    justify-content: space-between;
}

.separator {
    width: 100%;
    height: 2px;
    background-color: #d1d1d1;
    margin: 20px 0;
}

.wrapper {
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: flex-start;
    margin-left: 11%;
}

.text {
    font-size: 24px;
    color: #b9b9b9;
}

.buttons-container {
    display: flex;
    gap: 10px;
}

.btn {
    display: inline-flex;
    align-items: center;
    background-color: transparent;
    color: #999;
    border: 1px solid #ccc;
    border-radius: 20px;
    padding: 8px 15px;
    font-size: 14px;
    cursor: not-allowed;

    text-align: right;
    font: italic 400 18px/22px Barlow;
    letter-spacing: -0.27px;
    opacity: 1;
}

.icon {
    margin-left: 8px;
    opacity: 0.5;
    width: 22px;
    height: 19px;
}

.add-to-board-btn .icon {
    opacity: 0.5;
    width: 24px;
    height: 22px;
    margin-left: 10px;
    margin-top: -3px;
}

.profile-placeholder {
    width: 400px;
    height: 420px;
    background: transparent;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #BCBAB6;
}

.avatar-placeholder {
    width: 100px;
    height: 100px;
    background: #ddd;
    border-radius: 50%;
}

.text-placeholder {
    width: 80%;
    height: 20px;
    background: #ddd;
    border-radius: 4px;
}

.text-placeholder.short {
    width: 60%;
}

.text-placeholder.long {
    width: 100%;
}

@media only screen and (max-width: 790px) {
    .buttons-container {
        display: flex;
        justify-content: space-between;
        gap: 10px;
    }

    .wrapper {
        justify-content: center;
        margin-left: unset !important;
    }

    .text {
        display: none;
    }

    .search-result {
        border-bottom: unset;
        padding-bottom: unset;
    }

    .top-section {
        margin-top: unset;
        padding-top: unset;
        padding-bottom: unset;
        margin-bottom: unset;
        width: 100%;
        margin-left: 5px;
    }

    .btn {
        font-size: 16px;
    }
}
</style>
